import React, { useEffect } from 'react'

const WordPressContentFilter = ({ children }) => {
  useEffect(() => {
    // Funktion zum Entfernen von Facebook-Sharing und anderen unerwünschten Elementen
    const removeFacebookSharing = () => {
      const selectors = [
        '.fb-share-button',
        '.fb-share-wrapper',
        '[class*="fb-share"]',
        '[class*="facebook-share"]',
        '[id*="fb-share"]',
        '[id*="facebook-share"]',
        '.wp-block-jetpack-sharing',
        '.sharedaddy',
        '.sd-sharing',
        '.jetpack-sharing-buttons',
        '.sd-content',
        '.wp-block-social-links'
      ]

      selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector)
        elements.forEach(element => {
          element.style.display = 'none'
          element.style.visibility = 'hidden'
          element.remove()
        })
      })

      // Entferne auch Facebook-Skripte und iFrames
      const scripts = document.querySelectorAll('script[src*="facebook"], script[src*="fb"]')
      scripts.forEach(script => script.remove())

      const iframes = document.querySelectorAll('iframe[src*="facebook"], iframe[src*="fb"]')
      iframes.forEach(iframe => iframe.remove())

      // Entferne divs mit Facebook-bezogenen Attributen
      const facebookDivs = document.querySelectorAll('div[data-fb-xfbml-state], div[fb-xfbml-state]')
      facebookDivs.forEach(div => div.remove())
    }

    // Führe die Bereinigung durch, wenn der Inhalt geladen ist
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          removeFacebookSharing()
        }
      })
    })

    // Beobachte den Body für Änderungen
    observer.observe(document.body, {
      childList: true,
      subtree: true
    })

    // Führe sofort aus
    removeFacebookSharing()

    // Cleanup
    return () => {
      observer.disconnect()
    }
  }, [])

  return <>{children}</>
}

export default WordPressContentFilter